const today = new Date();
const currentYear = today.getFullYear();
const loginYear = 2021;

export const loadsData = {
    "data": {
        "total_count": 126,
        "loads": [
            {
                "id": "070ae175-20a9-48c8-b34a-367517fb6ec1",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "6339.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-27T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "15:56:00",
                "pick_up_time_end": "15:56:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "Woodland,CA",
                    "city": "Woodland",
                    "state": "CA",
                    "lat_long": "38.67851570000001,-121.7732971",
                    "lat": "38.67851570000001",
                    "lon": "-121.7732971",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Sacramento,CA",
                    "city": "Sacramento",
                    "state": "CA",
                    "lat_long": "38.4929881,-121.3884671",
                    "lat": "38.4929881",
                    "lon": "-121.3884671",
                    "abbr": "CA"
                },
                "distance_destination": 0,
                "distance_origin": 146.49
            },
            {
                "id": "0806a561-9a22-4e34-9f1a-ddb4d615600c",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "42538.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "13:00:00",
                "pick_up_time_end": "13:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "American Canyon,CA",
                    "city": "American Canyon",
                    "state": "CA",
                    "lat_long": "38.1749178,-122.2608044",
                    "lat": "38.1749178",
                    "lon": "-122.2608044",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Chino,CA",
                    "city": "Chino",
                    "state": "CA",
                    "lat_long": "34.0120229,-117.6786847",
                    "lat": "34.0120229",
                    "lon": "-117.6786847",
                    "abbr": "CA"
                },
                "distance_destination": 0,
                "distance_origin": 186.05
            },
            {
                "id": "124c2811-6c90-4a43-8b4a-35b55b279db9",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "20481.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "16:00:00",
                "pick_up_time_end": "16:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1642846779,
                "updated_at": 1642846779,
                "days": null,
                "origin": {
                    "name": "American Canyon,CA",
                    "city": "American Canyon",
                    "state": "CA",
                    "lat_long": "38.1749178,-122.2608044",
                    "lat": "38.1749178",
                    "lon": "-122.2608044",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "City of Industry,CA",
                    "city": "City of Industry",
                    "state": "CA",
                    "lat_long": "34.0541034,-117.9893301",
                    "lat": "34.0541034",
                    "lon": "-117.9893301",
                    "abbr": "CA"
                },
                "distance_origin": 186.05,
                "distance_destination": 0
            },
            {
                "id": "07063b29-1a56-47e1-b791-0c0c79434704",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "43000.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-25T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "10:00:00",
                "pick_up_time_end": "16:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-26T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "Parlier,CA",
                    "city": "Parlier",
                    "state": "CA",
                    "lat_long": "36.6116174,-119.5270734",
                    "lat": "36.6116174",
                    "lon": "-119.5270734",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Fontana,CA",
                    "city": "Fontana",
                    "state": "CA",
                    "lat_long": "34.0482749,-117.4438924",
                    "lat": "34.0482749",
                    "lon": "-117.4438924",
                    "abbr": "CA"
                },
                "distance_destination": 0,
                "distance_origin": 316.88
            },
            {
                "id": "037c21f6-6729-421d-a8bb-26ba98320031",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "0.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-27T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "08:00:00",
                "pick_up_time_end": "23:45:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-28T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1642846779,
                "updated_at": 1642846779,
                "days": null,
                "origin": {
                    "name": "Santa Clarita,CA",
                    "city": "Santa Clarita",
                    "state": "CA",
                    "lat_long": "34.3677169,-118.4747173",
                    "lat": "34.3677169",
                    "lon": "-118.4747173",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Tolleson,AZ",
                    "city": "Tolleson",
                    "state": "AZ",
                    "lat_long": "33.4500425,-112.259321",
                    "lat": "33.4500425",
                    "lon": "-112.259321",
                    "abbr": "AZ"
                },
                "distance_destination": 0,
                "distance_origin": 445.97
            },
            {
                "id": "1476b753-b89a-409a-be4f-3f8ed2731d99",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "0.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "11:00:00",
                "pick_up_time_end": "11:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "Santa Clarita,CA",
                    "city": "Santa Clarita",
                    "state": "CA",
                    "lat_long": "34.3677169,-118.4747173",
                    "lat": "34.3677169",
                    "lon": "-118.4747173",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Phoenix,AZ",
                    "city": "Phoenix",
                    "state": "AZ",
                    "lat_long": "33.4304026,-112.2026347",
                    "lat": "33.4304026",
                    "lon": "-112.2026347",
                    "abbr": "AZ"
                },
                "distance_origin": 445.97,
                "distance_destination": 0
            },
            {
                "id": "148e441f-7a49-4cd3-8f10-4ad3a5ebe6d0",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "0.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "14:00:00",
                "pick_up_time_end": "14:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1642846779,
                "updated_at": 1642846779,
                "days": null,
                "origin": {
                    "name": "Santa Clarita,CA",
                    "city": "Santa Clarita",
                    "state": "CA",
                    "lat_long": "34.3677169,-118.4747173",
                    "lat": "34.3677169",
                    "lon": "-118.4747173",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Phoenix,AZ",
                    "city": "Phoenix",
                    "state": "AZ",
                    "lat_long": "33.4304026,-112.2026347",
                    "lat": "33.4304026",
                    "lon": "-112.2026347",
                    "abbr": "AZ"
                },
                "distance_origin": 445.97,
                "distance_destination": 0
            },
            {
                "id": "12934103-1a7c-4cdc-b758-c318f3f71553",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "42223.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "11:30:00",
                "pick_up_time_end": "11:30:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-27T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643089409,
                "updated_at": 1643089409,
                "days": null,
                "origin": {
                    "name": "Las Vegas,NV",
                    "city": "Las Vegas",
                    "state": "NV",
                    "lat_long": "36.3193563,-115.0228736",
                    "lat": "36.3193563",
                    "lon": "-115.0228736",
                    "abbr": "NV"
                },
                "destination": {
                    "name": "Tolleson,AZ",
                    "city": "Tolleson",
                    "state": "AZ",
                    "lat_long": "33.4500425,-112.259321",
                    "lat": "33.4500425",
                    "lon": "-112.259321",
                    "abbr": "AZ"
                },
                "distance_destination": 0,
                "distance_origin": 459.78
            },
            {
                "id": "0bc619af-150b-4bef-aece-cd6a70ad971e",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "4678.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-26T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "00:00:00",
                "pick_up_time_end": "00:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-31T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "ONTARIO,CA",
                    "city": "ONTARIO",
                    "state": "CA",
                    "lat_long": "34.0348144,-117.5848025",
                    "lat": "34.0348144",
                    "lon": "-117.5848025",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "FINDLAY,OH",
                    "city": "FINDLAY",
                    "state": "OH",
                    "lat_long": "41.04422,-83.6499321",
                    "lat": "41.04422",
                    "lon": "-83.6499321",
                    "abbr": "OH"
                },
                "distance_destination": 0,
                "distance_origin": 461.95
            },
            {
                "id": "0b192b99-982c-472c-84c9-28df640a21e0",
                "type": "Daily",
                "trailer_type": "",
                "trip_distance": 0,
                "weight": "33390.00",
                "length": "0.00",
                "rate": "0.00",
                "pick_up_date": "2022-01-25T00:00:00.000Z",
                "pick_up_timezone": null,
                "pick_up_time_start": "09:00:00",
                "pick_up_time_end": "09:00:00",
                "delivery_timezone": null,
                "delivery_date_time": "2022-01-26T00:00:00.000Z",
                "full_partial": "Full",
                "driver_type": "Solo",
                "end_date": null,
                "load_details": null,
                "comments": null,
                "source": "Parade",
                "created_at": 1643010495,
                "updated_at": 1643010495,
                "days": null,
                "origin": {
                    "name": "Vernon,CA",
                    "city": "Vernon",
                    "state": "CA",
                    "lat_long": "34.00637469999999,-118.2234229",
                    "lat": "34.00637469999999",
                    "lon": "-118.2234229",
                    "abbr": "CA"
                },
                "destination": {
                    "name": "Sacramento,CA",
                    "city": "Sacramento",
                    "state": "CA",
                    "lat_long": "38.6418022,-121.5255815",
                    "lat": "38.6418022",
                    "lon": "-121.5255815",
                    "abbr": "CA"
                },
                "distance_destination": 0,
                "distance_origin": 476.72
            }
        ],
        "loadFilter": {
            "type": "daily",
            "driver_type": "Solo",
            "start_date": "2022-01-25T00:00:00.000Z",
            "distance_origin": "2000",
            "created_at": 1643112422,
            "updated_at": 1643112422,
            "origin": {
                "id": 1086,
                "city": "Reno",
                "state": "Nevada",
                "lat_long": "+39.52722, -119.82194",
                "lat": "39.527220",
                "lon": "-119.821940",
                "is_state": 0,
                "is_region": null,
                "name": "Reno, NV",
                "abbr": "NV",
                "region_id": null
            },
            "user": {
                "id": "a69a43118b584c11babc7d94b2f7ce0e",
                "name": "GNRO.P",
                "phone": "+10055555555",
                "email": "nar@mailinator.com",
                "type": "owner_operator",
                "image": "https://truckbook-dev-ohio.s3-us-east-2.amazonaws.com/assets/profile-images/a69a4311-8b58-4c11-babc-7d94b2f7ce0e.jpeg?v=1630666686",
                "device_type": "android",
                "home_city": null,
                "home_city_lat": null,
                "home_city_long": null,
                "postal_code": null,
                "created_at": 1621587615,
                "updated_at": 1641551676
            },
            "filter_timezone": null,
            "distance_destination": null,
            "day_ran": null,
            "full_partial": null,
            "end_date": null,
            "trailer_type": null,
            "id": "5af6fec4-73e4-4394-82cb-4a70e6266c73",
            "weight": "0.00",
            "length": "0.00"
        }
    }
};
